import { Accordion, Collapse, Group, UnstyledButton, Text, Stack, Divider, LoadingOverlay } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconCalendarEvent } from '@tabler/icons-react';
import { payoutOrderEventTypes, usePayoutOrderEvents } from '~/entities/payout';
import { KeyValuePair } from '~/shared/ui/KeyValuePair';
import { OrderDetails } from './OrderDetails';

interface OrderEventsProps {
    id: string;
}

export const OrderEvents = ({ id }: OrderEventsProps) => {
    const [opened, { toggle }] = useDisclosure(false);

    const events = usePayoutOrderEvents({ 'orderId.value': id });

    return (
        <Stack>
            <UnstyledButton onClick={toggle}>
                <Group>
                    <IconCalendarEvent />
                    Показать события
                </Group>
            </UnstyledButton>

            <Collapse expanded={opened}>
                <LoadingOverlay visible={events.isLoading} />
                <Accordion>
                    {events.data?.items?.length && events.data?.items?.length > 0 && !events.isLoading ? (
                        events.data?.items?.map((e) => (
                            <Accordion.Item
                                key={e.metadata?.createdAt}
                                value={e.metadata!.createdAt!}
                            >
                                <Accordion.Control>
                                    <Group
                                        wrap='nowrap'
                                        justify='space-between'
                                    >
                                        {e.metadata?.createdAt && (
                                            <KeyValuePair
                                                label='Дата'
                                                value={new Date(e.metadata?.createdAt).toLocaleString()}
                                            />
                                        )}
                                        {e.metadata?.type && (
                                            <KeyValuePair
                                                label='Тип'
                                                value={payoutOrderEventTypes[e.metadata?.type]}
                                            />
                                        )}
                                    </Group>
                                </Accordion.Control>

                                <Accordion.Panel>
                                    <Stack>
                                        {e.before && <OrderDetails order={e.before} />}

                                        {e.before && e.now && <Divider />}

                                        {e.now && <OrderDetails order={e.now} />}
                                    </Stack>
                                </Accordion.Panel>
                            </Accordion.Item>
                        ))
                    ) : (
                        <Text ta='center'>История остутствует</Text>
                    )}
                </Accordion>
            </Collapse>
        </Stack>
    );
};
